import { styled } from '@mui/material';

import { DESKTOP_MIN_WIDTH } from '~/constants/common';

export const StyledContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  paddingTop: '16px',
  paddingRight: '16px',
  flex: 1,
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    padding: '24px 16px 80px',
  },
}));

export const StyledContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: 1,
  gap: '20px',
  marginTop: '24px',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    marginTop: '0',
  },
}));
